import * as types from "./actionsTypes";

export function setNews(news) {
  return {
    type: types.SET_ITEMS,
    data: news,
  };
}

export function resetNews() {
  return {
    type: types.RESET_ITEMS,
  };
}
